export default __webpack_public_path__ + "static/media/qmyjjsb_page.a0fcaf1b.png";